/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PushNotificationCategoryResponse
 */
export interface PushNotificationCategoryResponse {
    /**
     * 
     * @type {string}
     * @memberof PushNotificationCategoryResponse
     */
    createdAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof PushNotificationCategoryResponse
     */
    defaultEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof PushNotificationCategoryResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof PushNotificationCategoryResponse
     */
    key: string;
}

/**
 * Check if a given object implements the PushNotificationCategoryResponse interface.
 */
export function instanceOfPushNotificationCategoryResponse(value: object): value is PushNotificationCategoryResponse {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('defaultEnabled' in value) || value['defaultEnabled'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    return true;
}

export function PushNotificationCategoryResponseFromJSON(json: any): PushNotificationCategoryResponse {
    return PushNotificationCategoryResponseFromJSONTyped(json, false);
}

export function PushNotificationCategoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PushNotificationCategoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'defaultEnabled': json['defaultEnabled'],
        'displayName': json['displayName'],
        'key': json['key'],
    };
}

export function PushNotificationCategoryResponseToJSON(value?: PushNotificationCategoryResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'createdAt': value['createdAt'],
        'defaultEnabled': value['defaultEnabled'],
        'displayName': value['displayName'],
        'key': value['key'],
    };
}

